export default __webpack_public_path__ + "Montserrat-Bold.ttf?0915f0a8c3367a6d05ec1e6bc6ba4abe";